import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export function awaitPipe<T = any>(result: Observable<any>) {
  return (source: Observable<T>) => source.pipe(switchMap((data: T) => result.pipe(map(() => data))));
}
